import React from "react";
import "./TTT.css";
import { Card, CardContainer } from "../../../components/Card";
import useSWR from "swr";
import API_ENDPOINTS from "../../../apis/endpoints";
import {
    Box,
    Checkbox,
    CircularProgress,
    FormControl,
    InputLabel,
    ListItemText,
    MenuItem,
    OutlinedInput,
    Select,
    Tab,
    Tabs,
    useTheme,
} from "@mui/material";
import { styled } from "@mui/styles";
import { BarChart, LineChart } from "../../../components/Charts";
import LinkedInTab from "./TTTLinkedIn";
import InstagramTab from "./TTTInstagram";
import FacebookTab from "./TTTFacebook";
import YoutubeTab from "./TTTYoutube";
import InvoiceTab from "./TTTInvoice";
import LastRefreshed from "../LastRefreshed";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 10.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const StyledTabs = styled(Tabs)(({ theme }) => ({
    borderBottom: `1px solid ${theme.palette.neutral[200]}`,
    "& .MuiTabs-indicator": {
        backgroundColor: theme.palette.secondary[500],
    },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(15),
    marginRight: theme.spacing(1),
    "&.Mui-selected": {
        color: theme.palette.secondary[500],
    },
}));

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const tabs = [
    { id: 0, title: "LinkedIn", rc: LinkedInTab },
    { id: 1, title: "Instagram", rc: InstagramTab },
    { id: 2, title: "Facebook", rc: FacebookTab },
    { id: 3, title: "YouTube", rc: YoutubeTab },
    { id: 4, title: "Invoice", rc: InvoiceTab },
];

export default function TTT() {
    const {
        data: weekDataSet,
        error: weekError,
        isLoading: weekIsLoading,
    } = useSWR(`${API_ENDPOINTS.TTT_WEEKS}`);

    const { data: weekData, refreshed_at } = weekDataSet ?? {};

    if (weekIsLoading) {
        return <CircularProgress />;
    }

    return <WeekDisplay weeks={weekData} refreshed_at={refreshed_at} />;
}

function WeekDisplay({ weeks, refreshed_at }) {
    const theme = useTheme();

    const [selectedWeeks, setSelectedWeeks] = React.useState(
        weeks.slice(-6).map((week) => week.key)
    );

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleWeekChange = (event) => {
        setSelectedWeeks(event.target.value);
    };

    return (
        <Card>
            <div className="header-section">
                <Box
                    sx={{
                        borderBottom: 1,
                        borderColor: theme.palette.neutral[200],
                    }}
                >
                    <StyledTabs
                        value={value}
                        onChange={handleChange}
                        aria-label="TTT tabs"
                    >
                        {tabs.map((tab, index) => (
                            <StyledTab
                                key={tab.id}
                                label={tab.title}
                                {...a11yProps(index)}
                            />
                        ))}
                    </StyledTabs>
                </Box>
                <FormControl sx={{ m: 1, width: 300 }}>
                    <InputLabel id="week-multi-select-label">Weeks</InputLabel>
                    <Select
                        labelId="week-multi-select-label"
                        id="week-multi-select"
                        multiple
                        value={selectedWeeks}
                        onChange={handleWeekChange}
                        input={<OutlinedInput label="All Weeks" />}
                        renderValue={(selected) =>
                            weeks.length === selectedWeeks.length
                                ? "All weeks"
                                : weeks
                                      ?.filter((week) =>
                                          selected.includes(week.key)
                                      )
                                      .map((week) => week.name)
                                      .join(", ")
                        }
                        MenuProps={MenuProps}
                    >
                        {weeks?.map((week) => (
                            <MenuItem key={week.key} value={week.key}>
                                <Checkbox
                                    checked={
                                        selectedWeeks.indexOf(week.key) > -1
                                    }
                                />
                                <ListItemText primary={week.name} />
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <SelectedWeeks
                weeks={selectedWeeks}
                tab={tabs.find((tab) => tab.id === value).rc}
            />
            <LastRefreshed date={refreshed_at} />
        </Card>
    );
}

function SelectedWeeks({ weeks, tab: T }) {
    const {
        data: academyData,
        error: academyError,
        isLoading: academyIsLoading,
    } = useSWR(`${API_ENDPOINTS.TTT_DATA}?weeks=${weeks.join(",")}`);

    if (academyIsLoading) {
        return <CircularProgress />;
    }

    return <div className="cards-container">{<T data={academyData} />}</div>;
}
